// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2daMW","modalForm":"UpgradeEpcsModal_modalForm__2M1H3","modalFooter":"UpgradeEpcsModal_modalFooter__3W2ZE"};